import auth, { TIdentityProvider } from '../services/auth';
import { OAUTH_QS_KEY } from '../constants/storage';
import queryString from '../services/queryString';
import redirect from './redirect';
import routes from '../constants/routes';
import routing from '../services/routing';
import storage from '../services/storage';
import { LOGIN_V2 } from '../constants/auth';

export const socialAuthorize = async (
    identityProvider: TIdentityProvider,
    onBeforeAuthorize?: () => void,
    onBeforeRedirect?: () => void
) => {
    // generate the custom idp URL
    const qs = queryString.parse(routing.location.search);
    const redirectUri = `${routing.location.protocol}//${routing.location.host}${routes.IDP_TOKEN}`;
    if (onBeforeAuthorize) onBeforeAuthorize();
    const res = LOGIN_V2
        ? await auth.authorizeV2({
              identityProvider,
              redirectUri,
          })
        : await auth.authorize({
              ...qs,
              identity_provider: identityProvider,
              redirect_uri: redirectUri,
          });
    // on a succesful response store current oauth params
    storage.saveState(OAUTH_QS_KEY, { ...qs });
    if (res?.data) {
        if (onBeforeRedirect) onBeforeRedirect();
        redirect(res.data);
    } else {
        throw new Error('Unable to authorize');
    }
};

export default socialAuthorize;
